<template>
    <div class="flex items-center gap-1.5">
        <button type="button" class="ds-month-shifts-panel-arrow" aria-label="Предыдущий месяц" @click="prevScheduleMonth()">
            <icon width="9" height="13">
                <IconChevronLeft />
            </icon>
        </button>
        <div class="ds-month-shifts-panel-month cursor-default first-letter:uppercase">
            {{ month }}
        </div>
        <button type="button" class="ds-month-shifts-panel-arrow" aria-label="Следующий месяц" @click="nextScheduleMonth()">
            <icon width="9" height="13">
                <IconChevronRight />
            </icon>
        </button>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'
import IconChevronLeft from '../../ui/icons/IconChevronLeft.vue'
import IconChevronRight from '../../ui/icons/IconChevronRight.vue'
import { useScheduleStore } from '@/stores/scheduleStore'

const store = useScheduleStore()

const emit = defineEmits(['date'])

const date = ref(store.currentScheduleDate)

const month = computed(() => date.value.format('MMMM YYYY'))

const nextScheduleMonth = () => {
        date.value = date.value.add(1, 'month')
        emit('date', date)
    }

const prevScheduleMonth = () => {
        date.value = date.value.subtract(1, 'month')
        emit('date', date)
    }

onMounted(() => {
    emit('date', date)
})
</script>
